// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".PageByPageView__PageByPageView___28985{width:100%}.PageByPageView__PageByPageView___28985:focus{outline:none}.PageByPageView__crossIcon___2EYV-{align-items:center;background-color:rgba(0,0,0,.4);border-radius:12px;display:flex;height:24px;justify-content:center;position:fixed;right:20px;top:20px;width:24px;z-index:1}.PageByPageView__crossIcon___2EYV-:hover{cursor:pointer}", ""]);
// Exports
exports.locals = {
	"PageByPageView": "PageByPageView__PageByPageView___28985",
	"crossIcon": "PageByPageView__crossIcon___2EYV-"
};
module.exports = exports;
